import { Component } from '@angular/core';

@Component({
  selector: 'app-counselling-dashboard-links',
  templateUrl: './counselling-dashboard-links.component.html',
  styleUrls: ['./counselling-dashboard-links.component.scss']
})
export class CounsellingDashboardLinksComponent {

}
